import { render, staticRenderFns } from "./Ward.vue?vue&type=template&id=301dca58&scoped=true"
import script from "./Ward.vue?vue&type=script&lang=js"
export * from "./Ward.vue?vue&type=script&lang=js"
import style0 from "./Ward.vue?vue&type=style&index=0&id=301dca58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301dca58",
  null
  
)

export default component.exports